import React, { Component } from 'react';
import { connect }          from 'react-redux';
import { NavLink }          from 'react-router-dom';

import * as popups from '../../constants/popup-types';

//Import actions
import { setBurgerState, setBurgerAnimate, addPopup } from 'redux/actions';

//components
import DynamicLink from "../../components/routing/dynamicLink/dynamicLink";

//Assets
import './burger.scss';
import background from 'assets/design/burger_background.svg';
import home_icon from 'assets/icons/home_icon_white.svg';
import like_icon from 'assets/icons/heart_icon_white.svg';

class BurgerMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            active_class: ''
        }
        this.handleCloseClick = this.handleCloseClick.bind(this);
        this.setBurgerState = this.setBurgerState.bind(this);
        this.handleLikesOnClick = this.handleLikesOnClick.bind(this);
    }

    handleCloseClick() {
        this.refs.burgerMenu.addEventListener('webkitTransitionEnd', this.setBurgerState)
        this.setState({active_class:''});
        this.props.setBurgerAnimate(false);
    }

    handleLikesOnClick(){
        this.handleCloseClick();
        const settings = {type:popups.FAVORITES};
        this.props.addPopup(settings);
    }

    setBurgerState() {
        this.refs.burgerMenu.removeEventListener('webkitTransitionEnd', this.setBurgerState);
        this.props.setBurgerState(false);
    }


    //Takes care of component animation after it is inserted into the DOM
    componentDidMount() {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.setState({active_class: ' active'});
                this.props.setBurgerAnimate(true);
            })
        })
    }

    render() {

        const menuItems = this.props.menu;
        let menu = [];
        if (Object.keys(menuItems).length > 0) {
            for(let key in menuItems){
                menu.push(
                    <li className="item" key={key}>
                        <DynamicLink data={menuItems[key].link} onClick={this.handleCloseClick}>
                            <span> {menuItems[key].title} </span>
                        </DynamicLink>
                    </li>
                );
            };
        }

        return (
            <div className= { 'burger_menu' + this.state.active_class } ref = 'burgerMenu' onClick = { this.handleCloseClick }>
                <div className = "menu">
                    <div className="top_links">
                        <NavLink to='/' className="link" onClick={this.handleCloseClick}>
                            <img className='icon' src = { home_icon } alt="home" />
                            <label className="label">דף הבית</label>
                        </NavLink>
                        <div className="divider">|</div>
                        <div className="link" onClick={this.handleLikesOnClick}>
                            <img className='icon' src = { like_icon } alt="like" />
                            <label className="label">אהבתי</label>
                        </div>
                    </div>
                    <ul>
                        { menu }
                    </ul>
                </div>
                <div className="design">
                    <img src = { background } alt="burger menu background" />
                </div>
            </div>
        )
    }
}
const mapStateToProps = store => {
    return {
        menu: store.config.Menu
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setBurgerState: (state) => dispatch(setBurgerState(state)),
        setBurgerAnimate: (state) => dispatch(setBurgerAnimate(state)),
        addPopup: (payload) => dispatch(addPopup(payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(BurgerMenu);
